export class ConfigDB {
  static data = {
    settings: {
      layout_type: "rtl",
      sidebar: {
        type: 'compact-wrapper',
      },
      sidebar_settings:  'default-sidebar',
    },
    color: {
      primary_color: "#FFCC03",
      secondary_color: "#ffcc33",
      mix_background_layout: "light-only",
    },
    router_animation: "fadeIn",
  };
}
export default ConfigDB;
